<template>
  <img src="@/assets/img/Icons/gallery/gallery.svg" />
</template>

<script>
export default {}
</script>

<style></style>
